/**
 * File: careData.ts
 * Path: packages/config/src/pricing/careData.ts
 * Description: Monthly care plans. Builds are paid once; care is the separate
 * monthly service that keeps them running (pricing ladder v2, 2026-10-13).
 */
import type { CarePlan, CarePlanId } from "./pricingTypes";

export const CARE_PLANS: Record<CarePlanId, CarePlan> = {
  site: {
    id: "site",
    name: "Site Care",
    amount: 600,
    covers: "Hosting, backups, security and small edits.",
  },
  booking: {
    id: "booking",
    name: "Booking Site Care",
    amount: 1200,
    covers:
      "Everything in Site Care, plus bookings and payments kept working.",
  },
  app: {
    id: "app",
    name: "App Care",
    amount: 3000,
    covers: "Hosting, updates, fixes and support for your app.",
  },
  priority: {
    id: "priority",
    name: "App Priority Care",
    amount: 6000,
    covers: "App Care, with same-day fixes and monthly improvements.",
  },
};
